<template>
  <div class="dispute-shipment-info">
    <div v-if="dataLength">
      <span class="dispute-shipment-info-header">Shipment Overview</span>
      <div class="dispute-shipment-info-overview">
        <div
          v-for="(value, key) in getOverviewData()"
          :key="`${value}-${key}`"
          class="dispute-shipment-info-overview--item"
          :class="key">
          <span class="dispute-shipment-info-overview--item-required-header">{{
            getKeyName(key)
          }}</span>
          <span class="dispute-shipment-info-overview--item-required-details">{{
            getOverviewValue(key, value) || "-"
          }}</span>
        </div>
      </div>
      <!-- 
        Container Details in the Shipment Information Tab is not available.
      -->
      <!-- <div
        v-for="(item, index) in shipmentInfoData.containers"
        :key="index"
        class="dispute-shipment-info-container"
      >
        <div class="dispute-shipment-info-container-header" @click="handleHeaderClick(item, index)">
          <div class="dispute-shipment-info-container-header--left">
            <span>{{ `Container ${index + 1}` }}</span>
          </div>
          <div class="dispute-shipment-info-container-header--right">
            <span v-if="!item.isOpen" class="mi-24px mi-chevron-down"></span>
            <span v-else class="mi-24px mi-chevron-up"></span>
          </div>
        </div>
        <div v-if="item.isOpen" class="dispute-shipment-info-container-contents">
          <div
            v-for="(value, key) in item"
            :key="`${value}-${key}`"
            class="dispute-shipment-info-container-contents--item"
          >
            <span
              class="dispute-shipment-info-container-contents--item-required-header"
            >{{ getKeyName(key) }}</span>
            <span
              v-if="key !== 'isOpen'"
              class="dispute-shipment-info-container-contents--item-required-details"
            >{{ value || "-" }}</span>
          </div>
        </div>
      </div>-->
    </div>
    <h4 v-else class="dispute-shipment-info-not-found">
      No Shipment Information Found
    </h4>
  </div>
</template>

<script>
// Utils
import { format } from "date-fns";

export default {
  name: "DisputeShipmentInfo",
  props: {
    data: {
      type: Object,
      default() {
        return;
      },
    },
  },
  computed: {
    dataLength() {
      return Object.keys(this.data).length ? true : false;
    },
  },
  methods: {
    handleHeaderClick(data, index) {
      event.stopPropagation();
      let newArray = [...this.data.containers];
      newArray[index] = {
        ...data,
        isOpen: !data.isOpen,
      };
      this.data.containers = newArray;
    },
    getKeyName(key) {
      const regex = /_/g;
      return key === "isOpen" ? "" : key.replace(regex, " ");
    },
    getOverviewValue(key, value) {
      try {
        return key === "Destination_arrival_date" || key === "Latest_pcd"
          ? format(new Date(value), "dd-MMM-yyyy hh:mm a")
          : value;
      } catch (err) {
        return value;
      }
    },
    getOverviewData() {
      let overviewData = { ...this.data };
      delete overviewData["containers"];
      return overviewData;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.dispute-shipment-info {
  &-header {
    font-family: "Maersk Text Bold";
    color: var(--Blue-900-Darkest);
  }

  &-not-found {
    color: var(--Gray-900);
    margin-bottom: 1rem;
  }

  &-container {
    margin: 1rem 0;
    cursor: pointer;
    position: relative;

    &-header {
      background: var(--Gray-100);
      border-radius: 0.25rem;
      padding: 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &--left {
        display: flex;
        align-items: center;

        span {
          font-family: "Maersk Text Bold";
          color: var(--Blue-900-Darkest);
        }
      }
    }

    &-contents {
      padding: 1.5rem;
      padding-bottom: 0;
      border: 1px solid var(--Gray-200);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;

      &--item {
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;

        &-required-header {
          color: var(--Gray-600);
          text-transform: capitalize;
        }
      }
    }
  }

  &-overview {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    margin-top: 1rem;

    &--item {
      display: flex;
      flex-direction: column;
      padding: 0.5rem;
      border: 1px solid var(--Gray-300);

      &:first-child {
        border-top-left-radius: 4px;
      }

      &:nth-child(10) {
        border-top-right-radius: 4px;
      }

      &:nth-child(11) {
        border-bottom-left-radius: 4px;
      }

      &:nth-last-child(1) {
        border-bottom-right-radius: 4px;
      }

      &-required-header {
        color: var(--Gray-600);
      }
    }
  }
}
</style>
